import { StatusCodes } from "http-status-codes";
import { headers } from "../../../../config/config";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { request } from "../../api";
import { MESSAGE } from "../../../../constants/api/message";

const { post, get, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "auth";

export type EditMemberCredentialPayloadTypes = {
	group_number: number;
	SSN: string;
	email: string;
	user_name: string;
};

// eslint-disable-next-line arrow-parens
export const editMemberCredentials = async (_payload: EditMemberCredentialPayloadTypes) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/edit-member-credentials`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};
